import { render } from "./oopsBanner2.vue?vue&type=template&id=744ae596"
import script from "./oopsBanner2.vue?vue&type=script&lang=js"
export * from "./oopsBanner2.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__